<template src="./MonthlyReportPage.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import { monthlyReportModule } from "@/store/modules/monthlyReport";
import { MonthlyReportGetters } from "@/store/modules/monthlyReport/getters";
import { MonthlyReportActions } from "@/store/modules/monthlyReport/actions";
import { MonthlyReport } from "@/models/reports/MonthlyReport";
import MonthlyReportDialog from "@/components/MonthlyReportDialog";
import MonthlyReportContent from "@/components/MonthlyReportContent";

export default defineComponent({
    components: {
        MonthlyReportDialog,
        MonthlyReportContent
    },
    computed: {
        ...monthlyReportModule.mapGetters({
            monthlyReportGetter: MonthlyReportGetters.MonthlyReport,
            isLoading: MonthlyReportGetters.IsLoading
        })
    },
    data() {
        return {
            englishDialogVisible: false,
            germanDialogVisible: false,
            englishContent: "",
            germanContent: "",
            englishSignature: "",
            germanSignature: ""
        };
    },
    methods: {
        ...monthlyReportModule.mapActions({
            loadMonthlyReport: MonthlyReportActions.LoadMonthlyReport,
            updateMonthlyReport: MonthlyReportActions.UpdateMonthlyReport
        }),
        async saveEnglishContent(
            content: string,
            signature: string
        ): Promise<void> {
            this.englishContent = content;
            this.englishSignature = signature;
            await this.confirmMonthlyReportChange();
        },
        async saveGermanContent(
            content: string,
            signature: string
        ): Promise<void> {
            this.germanContent = content;
            this.germanSignature = signature;
            await this.confirmMonthlyReportChange();
        },
        async confirmMonthlyReportChange(): Promise<void> {
            const monthlyReport: Partial<MonthlyReport> = {
                englishContent: this.englishContent,
                germanContent: this.germanContent,
                englishSignature: this.englishSignature,
                germanSignature: this.germanSignature
            };
            await this.updateMonthlyReport(monthlyReport);
            this.englishDialogVisible = false;
            this.germanDialogVisible = false;
        }
    },
    async created() {
        await this.loadMonthlyReport();
        if (this.monthlyReportGetter) {
            this.englishContent = this.monthlyReportGetter.englishContent ?? "";
            this.germanContent = this.monthlyReportGetter.germanContent ?? "";
            this.englishSignature =
                this.monthlyReportGetter.englishSignature ?? "";
            this.germanSignature =
                this.monthlyReportGetter.germanSignature ?? "";
        }
    }
});
</script>
